var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgForgotPassword(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 33C5 17.536 17.536 5 33 5s28 12.536 28 28-12.536 28-28 28S5 48.464 5 33z",
    fill: "#FFD9CE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m37.084 27.75 4.083-4.084m2.333-2.333-2.333 2.333 2.333-2.333zM32.29 32.545a6.417 6.417 0 1 1-9.075 9.074 6.417 6.417 0 0 1 9.074-9.073v-.001zm0 0 4.795-4.795-4.795 4.795zm4.795-4.795 3.5 3.5 4.083-4.084-3.5-3.5-4.083 4.084z",
    stroke: "#FF7B52",
    strokeWidth: 2.333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33 56c-12.703 0-23-10.297-23-23H0c0 18.225 14.775 33 33 33V56zm23-23c0 12.703-10.297 23-23 23v10c18.225 0 33-14.775 33-33H56zM33 10c12.703 0 23 10.297 23 23h10C66 14.775 51.225 0 33 0v10zm0-10C14.775 0 0 14.775 0 33h10c0-12.703 10.297-23 23-23V0z",
    fill: "#FFECE6"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgForgotPassword);
export default __webpack_public_path__ + "static/media/forgot-password.0fa4d1d4fdc8945ad1246f279ed78285.svg";
export { ForwardRef as ReactComponent };